const Dashboard = () => import('./components');

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Resumo',
    },
    component: Dashboard,
  },
];
